import { Link } from "react-router-dom";
const subMenu = ({
  subMenuArray,
  activeMenu,
  activechanged,
  adminMenuClick,
}) => {
  return (
    <>
      {subMenuArray.map((e) => (
        <li>
          <Link
            onClick={(event) => adminMenuClick(event, e.name)}
            className={activeMenu === e.name ? "active" : ""}
            to={e.url}
          >
            {" "}
            {e.name}
          </Link>
        </li>
      ))}
    </>
  );
};

export default subMenu;
